<form [formGroup]="addressDetailsForm" class="form-group overflow-visible">
  <div class="form-header rounded-t 2xl:rounded-l 2xl:h-auto" [ngClass]="{ 'w-full': !isExpanded }">
    <div class="items-center flex justify-between" (click)="collapsible ? collapseForm() : null">
      <div class="flex flex-col" [ngClass]="{ 'flex justify-between': !isExpanded }">
        <div class="flex gap-2 w-full items-center">
          <div class="bg-turquoise-bright/15 size-10 flex justify-center items-center rounded">
            <ion-icon
              name="{{ formTitle === 'Billing Details' ? 'card-outline' : 'location-outline' }}"
              class="size-6 text-turquoise-bright mt-0.5"
            ></ion-icon>
          </div>
          <div>
            <span>{{ formTitle }}</span>
            @if (formOptional) {
              <div class="text-xs font-light text-grey-mid">Optional</div>
            }
          </div>
        </div>
      </div>
      @if (collapsible) {
        <button
          class="btn-icon size-10 m-0"
          [tooltip]="isExpanded ? 'Collapse Section' : 'Expand Section'"
          [ngClass]="{ 'bg-grey-blue text-white border-0': isExpanded }"
        >
          <ion-icon
            class="size-5"
            name="{{ isExpanded ? 'chevron-collapse-outline' : 'chevron-expand-outline' }}"
          ></ion-icon>
        </button>
      }
    </div>
  </div>
  @if (isExpanded) {
    <div class="form-body">
      @if (context !== 'leads') {
        <div
          class="form-input"
          [ngClass]="{
            'has-error':
              addressDetailsForm.controls['country_alpha2_code'].errors &&
              addressDetailsForm.controls['country_alpha2_code'].touched,
          }"
        >
          @if (
            !(
              addressDetailsForm.controls['country_alpha2_code'].errors &&
              addressDetailsForm.controls['country_alpha2_code'].touched
            )
          ) {
            <label> Country </label>
          }
          @if (
            addressDetailsForm.controls['country_alpha2_code'].errors &&
            addressDetailsForm.controls['country_alpha2_code'].touched
          ) {
            <label>
              <ion-icon name="alert-circle" class="text-base"></ion-icon>
              @if (addressDetailsForm.controls['country_alpha2_code'].hasError('required')) {
                <div class="error">Country is required</div>
              }
            </label>
          }
          <select
            id="country"
            placeholder="country"
            formControlName="country_alpha2_code"
            class="form-control"
            (change)="countryChange($event)"
          >
            @for (country of countries$ | async; track country?.attributes?.alpha2_code ?? $index) {
              <option [value]="country?.attributes?.alpha2_code">
                {{ country?.attributes?.alpha2_code | emojiFlag }} &nbsp;{{ country?.attributes?.name }}
              </option>
            }
          </select>
        </div>
      }
      @if (context !== 'leads') {
        <div class="form-input">
          <label>Unit</label>
          <input id="unit" placeholder="optional" clear-input="true" formControlName="unit" type="text" />
        </div>
      }
      <div
        class="form-input"
        [ngClass]="{
          'has-error':
            addressDetailsForm.controls['street_address'].errors &&
            addressDetailsForm.controls['street_address'].touched,
        }"
      >
        @if (
          !(
            addressDetailsForm.controls['street_address'].errors &&
            addressDetailsForm.controls['street_address'].touched
          )
        ) {
          <label> Street Address </label>
        }
        @if (
          addressDetailsForm.controls['street_address'].errors && addressDetailsForm.controls['street_address'].touched
        ) {
          <label id="street-address-error">
            <ion-icon name="alert-circle" class="text-base"></ion-icon>
            @if (addressDetailsForm.controls['street_address'].errors?.['required']) {
              <div class="error">Address is required</div>
            }
          </label>
        }
        <lib-places-autocomplete
          id="street-address"
          [countryRestrictions]="[selectedCountry.attributes.alpha2_code]"
          [optional]="formOptional"
          [value]="addressDetailsForm.get('street_address')?.value"
          formControlName="street_address"
          (placeSelected)="addressChange($event); postalCodeRef.focus()"
          [ngClass]="{
            '*:pointer-events-none [&_input]:bg-grey-concrete/50 [&_input]:shadow-none *:text-grey-mid/70':
              addressDetailsForm.disabled,
          }"
        ></lib-places-autocomplete>
      </div>
      <div class="flex gap-2 relative">
        <div class="form-input w-1/2">
          <label>Suburb</label>
          <input
            id="suburb"
            placeholder="optional"
            clear-input="true"
            formControlName="suburb"
            type="text"
            data-1p-ignore
          />
        </div>
        <div
          class="form-input w-1/2"
          [ngClass]="{
            'has-error': addressDetailsForm.controls['city'].errors && addressDetailsForm.controls['city'].touched,
          }"
        >
          @if (!(addressDetailsForm.controls['city'].errors && addressDetailsForm.controls['city'].touched)) {
            <label> City </label>
          } @else {
            <label id="city-error">
              <ion-icon name="alert-circle" class="text-base"></ion-icon>
              @if (addressDetailsForm.controls['city'].errors?.['required']) {
                <div class="error">City is required</div>
              }
            </label>
          }
          <input
            id="city"
            clear-input="true"
            data-1p-ignore
            formControlName="city"
            (focus)="addressDetailsForm.controls['city'].markAsUntouched()"
            placeholder="{{ formOptional ? 'optional' : '' }}"
            type="text"
          />
        </div>
      </div>
      <div class="flex gap-2 relative">
        @if (context !== 'leads') {
          <div
            class="form-input w-1/2"
            [ngClass]="{
              'has-error':
                addressDetailsForm.controls['province_code'].errors &&
                addressDetailsForm.controls['province_code'].touched,
            }"
          >
            @if (
              !(
                addressDetailsForm.controls['province_code'].errors &&
                addressDetailsForm.controls['province_code'].touched
              )
            ) {
              <label> Province </label>
            }
            @if (
              addressDetailsForm.controls['province_code'].errors &&
              addressDetailsForm.controls['province_code'].touched
            ) {
              <label id="province-error">
                <ion-icon name="alert-circle" class="text-base"></ion-icon>
                @if (addressDetailsForm.controls['province_code'].errors?.['required']) {
                  <div class="error">Province is required</div>
                }
              </label>
            }
            @if (!!selectedCountry) {
              <select
                id="province"
                placeholder="province"
                formControlName="province_code"
                class="form-control transition-none font-normal text-base"
                [ngClass]="{
                  'text-grey-mid/75 font-light text-sm': !addressDetailsForm.controls['province_code'].value,
                }"
              >
                <option [value]="null" disabled selected>Select Province...</option>
                @for (province of selectedCountry.attributes.provinces; track province?.code ?? $index) {
                  <option [value]="province?.code">
                    {{ province?.name }}
                  </option>
                }
              </select>
            }
          </div>
        }
        <div
          class="form-input w-1/2"
          [ngClass]="{
            'has-error':
              addressDetailsForm.controls['postal_code'].errors && addressDetailsForm.controls['postal_code'].touched,
          }"
        >
          @if (
            !(addressDetailsForm.controls['postal_code'].errors && addressDetailsForm.controls['postal_code'].touched)
          ) {
            <label> Postal Code </label>
          }
          @if (
            addressDetailsForm.controls['postal_code'].errors && addressDetailsForm.controls['postal_code'].touched
          ) {
            <label id="postal-code-error">
              <ion-icon name="alert-circle" class="text-base"></ion-icon>
              @if (addressDetailsForm.controls['postal_code'].errors?.['required']) {
                <div class="error">Postal required</div>
              }
            </label>
          }
          <input
            id="postal-code"
            #postalCodeRef
            data-1p-ignore
            placeholder="{{
              options.componentRestrictions.country === 'ZA' && !formOptional
                ? ''
                : formOptional
                  ? 'optional'
                  : 'optional'
            }}"
            (focus)="addressDetailsForm.controls['postal_code'].markAsUntouched()"
            clear-input="true"
            formControlName="postal_code"
            type="text"
            class="w-24"
          />
        </div>
      </div>
    </div>
  }
</form>
